import { createContext } from 'react';
import { AxiosResponse } from 'axios';

import { CreateWorkerInvitesRequest, CreateWorkerInvitesResponse } from '@vyce/core/src/api/types';
import { CompanyWorkersRequest } from '@vyce/core/src/hooks/useCompanyWorkersList';
import { InvitePreselectedTarget } from '@vyce/core/src/views/invites/types';
import { FetchInviteResources } from '@vyce/core/src/views/invites/utils/fetchInviteResources';

interface Context {
  companyId: string;
  open: boolean;
  /**
   * How the dialog loads teams / locations / pay schedules for the company. Defaults to the
   * invite-scoped public/v1 routes (every resource of the company); Legend injects its admin routes here.
   */
  fetchResources?: FetchInviteResources;
  /**
   * Which route lists the existing users. Defaults to the invite-scoped search (every worker of
   * the company); Legend injects the companies workers route.
   */
  fetchWorkers?: CompanyWorkersRequest;
  /** Legend: nothing can be typed or picked until a company is chosen */
  disabledContactInput?: boolean;
  /**
   * Where the dialog was opened from — e.g. a location page. That module is expanded on the
   * "Where" step with the resource ticked, so the obvious target needs no second search.
   */
  preselectedTarget?: InvitePreselectedTarget;
  isLegend?: boolean;
  onClose: () => void;
  createInvitesRequest: (
    args: CreateWorkerInvitesRequest
  ) => Promise<AxiosResponse<CreateWorkerInvitesResponse>>;
  onSuccess?: () => void;
}

export const UniversalInviteContext = createContext({} as Context);

export const UniversalInviteProvider = UniversalInviteContext.Provider;
